$(window).scroll(function(){
  if($(document).scrollTop() > 0) {
    $('.header-left').addClass('sticky');
    $('.header-sticky-container').addClass('sticky');
  } else {
    $('.header-left').removeClass('sticky');
    $('.header-sticky-container').removeClass('sticky');
  }
});
